interface AttachmentConfiguration {
  MaximumFileSize: number
  MultipleFiles: boolean
  AcceptedFileTypes: {
    [key: string]: string[]
  }
}

export const FaxAttachmentConfig: AttachmentConfiguration = {
  MaximumFileSize: 1024 * 1024 * 25, // 25MB
  MultipleFiles: false,
  AcceptedFileTypes: {
    'image/png': ['.png'],
    'image/gif': ['.gif'],
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/bmp': ['.bmp'],
    'image/tiff': ['.tiff'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.docx',
    ],
    'application/vnd.oasis.opendocument.text': ['.odt'],
    'text/rtf': ['.rtf'],
    'text/plain': ['.txt'],
    'application/rtf': ['.rtf'],
    'text/csv': ['.csv'],
  },
}

export const FaxAttachmentConfigMultifile: AttachmentConfiguration = {
  MaximumFileSize: 1024 * 1024 * 25, // 25MB
  MultipleFiles: true,
  AcceptedFileTypes: {
    'image/png': ['.png'],
    'image/gif': ['.gif'],
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/bmp': ['.bmp'],
    'image/tiff': ['.tiff'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.docx',
    ],
    'application/vnd.oasis.opendocument.text': ['.odt'],
    'text/rtf': ['.rtf'],
    'text/plain': ['.txt'],
    'application/rtf': ['.rtf'],
    'text/csv': ['.csv'],
  },
}
